/**
 * Play muted loop videos only once they enter (or near) the viewport.
 * Expects wrappers marked with [data-deferred-video].
 * Playback waits for window load + idle so video streams never compete with
 * the LCP image and theme JS, and is skipped on Save-Data / slow connections.
 */
(function () {
  function prefersReducedData() {
    var connection = navigator.connection;
    if (!connection) return false;
    if (connection.saveData) return true;
    return /(^|-)(2g|3g)$/.test(connection.effectiveType || "");
  }

  function afterLoadAndIdle(callback) {
    var run = function () {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(callback, { timeout: 3000 });
      } else {
        window.setTimeout(callback, 200);
      }
    };

    if (document.readyState === "complete") {
      run();
    } else {
      window.addEventListener("load", run, { once: true });
    }
  }

  function playWhenVisible(root) {
    var videos = root.querySelectorAll("video");
    if (!videos.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var video = entry.target;
          video.play().catch(function () {});
          observer.unobserve(video);
        });
      },
      { rootMargin: "120px 0px", threshold: 0.01 }
    );

    videos.forEach(function (video) {
      video.setAttribute("preload", "none");
      video.addEventListener(
        "playing",
        function () {
          video.classList.add("is-playing");
        },
        { once: true }
      );
      observer.observe(video);
    });
  }

  function initWithin(scope) {
    if (prefersReducedData()) return;
    scope.querySelectorAll("[data-deferred-video]").forEach(playWhenVisible);
  }

  afterLoadAndIdle(function () {
    initWithin(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section) return;
    initWithin(section);
  });
})();
